import { Component } from '@angular/core';

@Component({
  selector: 'cx-reset-password-page-layout',
  templateUrl: './reset-password-page-layout.component.html',
  styles: ['./reset-password-page-layout.scss']
})
export class ResetPasswordLayoutComponent {}
